


















import VueOptions from '@utils/VueOptions'

settings = 
  name: "WaitListOrganizer"
  vue: 
    store: ['member']
    computed:
      typeformUrl: ->
        userId = @member.id
        console.log @member
        userEmail = encodeURIComponent @member.email
        firstName = encodeURIComponent @member.first_name
        lastName = encodeURIComponent @member.last_name
        phone = encodeURIComponent @member.phone
        "https://teamrecess.typeform.com/to/uAB4dT?first_name=#{firstName}&last_name=#{lastName}&phone=#{phone}&user_id=#{userId}&email=#{userEmail}"
    methods:
      bootTypeform: ->
        qs = js = q = s = undefined
        d = document
        gi = d.getElementById
        ce = d.createElement
        gt = d.getElementsByTagName
        id = 'typef_orm'
        b = 'https://embed.typeform.com/'
        if !gi.call(d, id)
          js = ce.call(d, 'script')
          js.id = id
          js.src = b + 'embed.js'
          q = gt.call(d, 'script')[0]
          q.parentNode.insertBefore js, q
    mounted: -> @bootTypeform()
export default VueOptions.vue settings
